export const news = [
  {
    id: "n1",
    title: "《星际迷航者》票房口碑双丰收，续作计划正式官宣",
    category: "影视新闻",
    publishDate: "2026-09-18",
    source: "白虎影视资讯",
    summary: "上映首周便登顶票房榜首，《星际迷航者》凭借震撼的视觉呈现与深刻的人文内核赢得观众一致好评，制片方宣布续集已进入筹备阶段。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20futuristic%20movie%20premiere%20event%20with%20glowing%20screens%20and%20warm%20orange%20spotlights%20against%20a%20dark%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-01&orientation=landscape",
    content: [
      "由白虎影视资讯综合报道，科幻电影《星际迷航者》自上映以来表现强劲，首周便登顶多地票房榜首，观众与专业影评人均给出高度评价。",
      "影片以人类深空探索为背景，通过一位领航员的抉择，探讨了孤独、信任与文明延续的宏大命题。导演在采访中表示，希望通过这个故事，让观众在浩瀚宇宙中看见人性的微光。",
      "据制片方透露，续作已正式立项，原班主创团队将悉数回归，故事将延续第一部的世界观，并展开全新的星际篇章。更多拍摄进展，白虎将持续关注。",
    ],
  },
  {
    id: "n2",
    title: "国产剧集出海提速，多部作品登陆海外流媒体平台",
    category: "行业动态",
    publishDate: "2026-09-15",
    source: "白虎影视资讯",
    summary: "随着内容品质不断提升，越来越多国产剧集走向海外市场，古装、悬疑与都市题材成为出海主力，文化输出成效持续显现。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20modern%20media%20conference%20stage%20with%20large%20screens%20and%20warm%20orange%20lighting%20against%20a%20dark%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-02&orientation=landscape",
    content: [
      "近年来，国产剧集在制作水准与叙事能力上不断精进，海外发行渠道也日趋成熟。多部作品相继登陆国际主流流媒体平台，覆盖上百个国家和地区。",
      "业内分析认为，古装、悬疑与都市题材因具备强烈的类型辨识度而更受海外观众青睐。字幕与配音的本地化质量，成为影响传播效果的关键因素之一。",
      "有制片人表示，出海不仅是商业行为，更是文化交流的窗口。未来行业将进一步探索符合全球观众审美、又保留本土文化特色的表达方式。",
    ],
  },
  {
    id: "n3",
    title: "《火星黎明》发布首支正式预告，视觉奇观引发热议",
    category: "影片预告",
    publishDate: "2026-09-11",
    source: "白虎影视资讯",
    summary: "备受期待的科幻巨制《火星黎明》释出首支正式预告，广袤的红色荒原与极致的摄影美学迅速引发社交平台讨论热潮。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20red%20martian%20desert%20landscape%20with%20a%20lone%20rover%20under%20a%20rising%20sun%20and%20warm%20orange%20glow%20against%20a%20dark%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-03&orientation=landscape",
    content: [
      "科幻电影《火星黎明》于近日发布首支正式预告片，短短两分钟的影像中，广袤寒冷的红色荒原与孤独前行的探索者形成强烈对比。",
      "预告片上线数小时内便登上多个社交平台热搜，观众对其极致的摄影美学与沉浸式的科幻设定给予高度评价。不少影迷表示，期待影片在视觉之外带来更深层的情感共鸣。",
      "影片将于年内上映，主创团队透露，故事将聚焦“人在异乡如何重建家园”的主题，力求在宏大叙事中保留细腻的人性刻画。",
    ],
  },
  {
    id: "n4",
    title: "悬疑题材持续升温，精品化创作成为行业共识",
    category: "行业动态",
    publishDate: "2026-09-06",
    source: "白虎影视资讯",
    summary: "悬疑作品凭借紧凑节奏与强代入感广受欢迎，越来越多创作者开始深耕剧本与人物塑造，推动该类型迈向精品化。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20dim%20interrogation%20room%20with%20a%20single%20desk%20lamp%20and%20warm%20orange%20light%20against%20a%20dark%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-04&orientation=landscape",
    content: [
      "近年来，悬疑类型作品在各大平台持续升温。紧凑的节奏、层层反转的叙事以及对人性深处的探讨，使其成为观众讨论度最高的类型之一。",
      "多位业内人士指出，悬疑作品的竞争核心正从“烧脑”转向“共情”。观众不再只满足于解谜的快感，更期待人物动机的真实与情感的可信。",
      "在精品化趋势下，剧本打磨周期普遍延长，制作团队也更注重细节还原与氛围营造。可以预见，未来将有更多兼具观赏性与思想性的悬疑佳作与观众见面。",
    ],
  },
  {
    id: "n5",
    title: "白虎影视观察：女性题材作品迎来创作新表达",
    category: "影视新闻",
    publishDate: "2026-08-29",
    source: "白虎影视资讯",
    summary: "越来越多聚焦女性成长与生活状态的作品进入大众视野，题材与视角的多元化，为影视市场注入新的活力。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20an%20elegant%20modern%20woman%20standing%20before%20a%20city%20window%20at%20dusk%20with%20warm%20orange%20light%20against%20a%20dark%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-05&orientation=landscape",
    content: [
      "近期，一批聚焦女性成长与生活状态的作品陆续与观众见面。这些作品不再局限于单一的情感线索，而是将镜头对准职场、家庭与自我实现的多重维度。",
      "创作者表示，真实的女性形象应当是立体的、复杂的，既有坚韧的一面，也有脆弱与挣扎。只有在细节中还原生活，才能引发更广泛的共鸣。",
      "随着观众审美的提升与市场需求的多样化，女性题材正呈现出更加丰富的创作面貌，成为推动行业内容升级的重要力量。",
    ],
  },
  {
    id: "n6",
    title: "经典老片修复重映，胶片美学重回大银幕",
    category: "影片预告",
    publishDate: "2026-08-22",
    source: "白虎影视资讯",
    summary: "多部经典老片以4K修复版本重返影院，细腻的胶片质感与隽永的叙事魅力，吸引新老观众走进影厅。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20vintage%20film%20projector%20beaming%20warm%20orange%20light%20in%20a%20dark%20cinema%20hall%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20editorial%20news%20photography%2C%20moody%20atmosphere%2C%20no%20text%2C%20highly%20detailed&width=800&height=500&seq=baihu-news-06&orientation=landscape",
    content: [
      "今年以来，多部经典老片经过4K修复后重新登上大银幕。修复团队对画面色彩、声音与胶片划痕进行了细致处理，让这些作品以更接近原貌的方式与观众重逢。",
      "不少年轻观众表示，第一次在大银幕上感受胶片独有的颗粒与光影质感，是流媒体播放无法替代的体验。而年长观众则在熟悉的画面中，重温了旧日时光。",
      "业内认为，经典重映不仅是对电影历史的致敬，也为当下创作提供了参照。如何在技术与内容之间找到平衡，值得行业持续思考。",
    ],
  },
];